import { render, staticRenderFns } from "./filterWords.vue?vue&type=template&id=13534edf&scoped=true&"
import script from "./filterWords.vue?vue&type=script&lang=js&"
export * from "./filterWords.vue?vue&type=script&lang=js&"
import style0 from "./filterWords.vue?vue&type=style&index=0&id=13534edf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13534edf",
  null
  
)

export default component.exports